import { PropsWithChildren, useState } from "react";
import { usePermission } from "@/hooks";
import { Model } from "@/types";
import { ModelDialog } from "./model-dialog";
import { FormModelCreate } from "./form-model-create";
import { FormModelUpdate } from "./form-model-update";

type FormModelsProps = PropsWithChildren & { model?: Model; disable?: boolean };
export function FormModels({ children, model, disable }: FormModelsProps) {
  const [open, setOpen] = useState(false);
  const { checkPermission } = usePermission();
  if (disable || !checkPermission("models", model ? "edit models" : "create models")) return null;
  return <ModelDialog wide editorLayout title={model ? "Editar modelo de contrato" : "Novo modelo de contrato"}
    description="Prepare o texto e insira campos que serão preenchidos ao gerar o contrato."
    trigger={children} open={open} onOpenChange={setOpen}>
    {model ? <FormModelUpdate model={model} handleClose={() => setOpen(false)} /> : <FormModelCreate handleClose={() => setOpen(false)} />}
  </ModelDialog>;
}
